/**
 * Compliance Baseline (STA-128, STA-137) — fixed disclaimer mounted on
 * the checkout page and below every reading result.
 *
 * Source of truth: docs/product/compliance/legal/v1.0/terms-of-service.md §9.
 * Keep the prose here in sync with the markdown if either changes.
 */

export const DISCLAIMER_TEXT =
  '免責聲明：本網站提供之塔羅占卜與解牌結果僅供個人心靈探索、娛樂與參考之用，不具備任何醫療、法律、財務投資或心理諮商之專業效力。占卜結果不代表絕對發生的未來，請勿以此取代專業人士之建議。若遇重大決策或身心不適，請務必尋求相關專業協助。使用者須對自身行為與決定負擔全部責任。';

export default function Disclaimer({ className = '' }: { className?: string }) {
  return (
    <p
      role="note"
      // WCAG AA — keeps body text contrast on the tarot-bg backdrop while
      // staying visually quieter than primary copy.
      className={
        'text-xs leading-relaxed text-tarot-muted border-t border-tarot-purple/20 pt-4 mt-8 ' +
        className
      }
    >
      {DISCLAIMER_TEXT}
    </p>
  );
}
